<script>
import messages from '@/mixins/messages'
import TermsOfServiceLink from './TermsOfServiceLink.vue'
import PaymentMethod from '../components/PaymentMethod.vue'
import { UserVoucherResource } from '@/resources/voucher'

export default {
    name: 'VoucherPitch',
    mixins: [messages],
    components: {
        TermsOfServiceLink,
        PaymentMethod
    },
    computed: {
        amountCents() {
            let userValue = parseInt(this.amountDollars)

            if (!userValue) {
                return 1e4
            }

            return userValue * 100
        },
    },
    watch: {
        userResource() {
            this.emailToFromName = this.userResource.fullName()
        }
    },
    data() {
        return {
            loading: true,
            amountDollars: 100,
            emailTo: false,
            emailToEmail: '',
            emailToFromName: '',
            emailToComments: '',
            userCardDetails: {},
            userResource: null,
            voucherResource: null,
            showSuccess: false
        }
    },
    methods: {
        async onSubmit() {
            try {
                this.loading = true
                const extraData = !this.emailTo ? undefined : {
                    emailTo: this.emailToEmail,
                    emailFromName: this.emailToFromName,
                    emailComments: this.emailToComments
                }

                this.voucherResource = await UserVoucherResource.purchaseGiftCard(this.amountCents, extraData)
                this.showSuccess = true
                this.$emit('success', this.voucherResource)
            } catch(e) {
                throw this.axiosExtract(e)
            } finally {
                this.loading = false
            }
        },
        async onCardAdded() {
            this.userCardDetails = await this.userResource.getCard()
        },
        onSuccess() {
            this.$emit('done')
        },
        onClose() {
            this.$emit('close')
        }
    },
    async mounted() {
        this.userResource = await this.$store.dispatch('getUserResource')
        this.userCardDetails = await this.userResource.getCard()
        this.loading = false
    }
}
</script>

<template>
    <div class="voucher-pitch">
        <b-row v-if="!loading && !showSuccess">
            <b-col>
                <b-form @submit.prevent="onSubmit">
                    <b-form-group label="Wert des Geschenkgutscheins" label-cols-md="6">
                        <b-input-group :prepend="currencySymbol()" append=".00">
                            <b-form-input type="number" v-model="amountDollars"></b-form-input>
                        </b-input-group>
                    </b-form-group>

                    <hr />

                    <p><strong>Ein Gutscheincode wird Ihnen per E-Mail zugesandt.</strong> Dieser Gutscheincode kann für die Buchung von Reservierungen für jeden Simulatortyp zu jedem Datum/Zeitpunkt verwendet werden.</p>
                    
                    <p><b-form-checkbox v-model="emailTo">Diesen Gutscheincode an jemanden Besonderen per E-Mail senden</b-form-checkbox></p>

                    <div v-if="emailTo">
                        <b-form-group label="E-Mail-Adresse des Empfängers">
                            <b-form-input type="email" v-model="emailToEmail" placeholder="E-Mail-Adresse"  :required="emailTo"></b-form-input>
                        </b-form-group>

                        <b-form-group label="Ihr Name">
                            <b-form-input v-model="emailToFromName" placeholder="Ihr Name" :required="emailTo"></b-form-input>
                        </b-form-group>

                        <b-form-group label="Zusätzliche Kommentare" description="Maximal 200 Zeichen">
                            <b-form-textarea v-model="emailToComments" placeholder="Z.B. 'Alles Gute zum Geburtstag!'" maxlength="200"></b-form-textarea>
                        </b-form-group>
                    </div>
                    
                    <div v-if="!Object.keys(userCardDetails).length">
                        <hr />
                        <payment-method cols-lg="12" :user-resource="userResource" @success="onCardAdded">
                            <b-alert variant="success" show><b-icon icon="lock-fill" /> Ihre Karte wird noch nicht belastet</b-alert>
                        </payment-method>
                    </div>
                    
                    <div v-else>
                        <b-alert variant="info" show>Ihre <strong>{{ userCardDetails.brand }} endet mit {{ userCardDetails.last4 }}</strong> wird mit {{ currencySymbol() }}{{ moneyFormat(amountCents) }} belastet.</b-alert>
                        <small class="text-muted"><terms-of-service-link /></small>
                        <messages class="mt-3" />
                        <b-button type="submit" class="col-sm-12 mt-3" :disabled="loading">Geschenkgutschein kaufen</b-button>
                    </div>
                </b-form>
            </b-col>
        </b-row>

        <div v-else-if="showSuccess">
            <b-alert variant="success" show><strong>Erfolg! Ihr Geschenkgutschein wurde gekauft!</strong> <span v-if="emailTo">Dieser Geschenkgutschein wurde auch an <strong>{{ emailToEmail }}</strong> gesendet</span></b-alert>
            <p>Bitte notieren Sie sich den untenstehenden Code. Die Eingabe dieses Codes beim Checkout wird den Kontostand dieses Gutscheins auf Ihre Checkout-Kosten anwenden.</p>
            <b-card header="Gutscheincode">
                <h4 class="text-center mb-0">
                    {{ voucherResource }}
                </h4>
            </b-card>
            <b-button variant="primary" class="col-sm-12 mt-3" @click="onSuccess">Alles erledigt</b-button>
        </div>

        <div v-else>
            <b-skeleton-wrapper>
                <b-skeleton width="85%"></b-skeleton>
                <b-skeleton width="55%"></b-skeleton>
                <b-skeleton width="70%"></b-skeleton>
            </b-skeleton-wrapper>
        </div>
    </div>
</template>

<style lang="scss">
</style>
